import { Asset, CustomField, CustomFieldTypes, formatDate } from "@thenounproject/lingo-core";

export default function formatAssetCustomFieldValue(field: CustomField, asset: Asset): string {
  const value = asset.fields?.[field.id];

  if (value === "" || value === null || value === undefined) return "—";

  switch (field.type) {
    case CustomFieldTypes.text:
    case CustomFieldTypes.number:
      return String(value);
    case CustomFieldTypes.date: {
      if (!value) return "—";
      return formatDate(value as string, "MMMM d, yyyy");
    }
    case CustomFieldTypes.select:
    case CustomFieldTypes.checklist: {
      const ids = Array.isArray(value) ? value : [];
      if (!ids.length || !field.options?.length) return "—";
      return ids
        .map(id => field.options.find(o => String(o.id) === String(id))?.name)
        .filter(Boolean)
        .join(", ");
    }
    default:
      return "";
  }
}
